/* Keep controls in off-screen Flickity cells out of the keyboard tab order. */
(function manageCarouselFocus() {
  const focusableSelector = 'a[href], button, input, select, textarea, summary, [tabindex]';
  const previousTabindexAttribute = 'data-flickity-previous-tabindex';

  function syncCell(cell) {
    const isHidden = cell.getAttribute('aria-hidden') === 'true';

    cell.querySelectorAll(focusableSelector).forEach(function(element) {
      if (isHidden) {
        if (!element.hasAttribute(previousTabindexAttribute)) {
          const previousTabindex = element.hasAttribute('tabindex')
            ? element.getAttribute('tabindex')
            : '__none__';
          element.setAttribute(previousTabindexAttribute, previousTabindex);
        }
        element.setAttribute('tabindex', '-1');
        return;
      }

      if (!element.hasAttribute(previousTabindexAttribute)) return;

      const previousTabindex = element.getAttribute(previousTabindexAttribute);
      if (previousTabindex === '__none__') {
        element.removeAttribute('tabindex');
      } else {
        element.setAttribute('tabindex', previousTabindex);
      }
      element.removeAttribute(previousTabindexAttribute);
    });
  }

  function syncCarousels(root) {
    if (root.matches?.('.flickity-slider > [aria-hidden]')) syncCell(root);
    root.querySelectorAll?.('.flickity-slider > [aria-hidden]').forEach(syncCell);
  }

  function init() {
    syncCarousels(document);

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') syncCell(mutation.target);
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
